import { z } from "zod";
import { ORDER_STATUSES } from "../constants/index.js";
import { SHOP_ORDER_STATUSES } from "../shop/index.js";
export const profileSchema = z.object({
    fullName: z.string().min(2).max(200),
    phone: z.string().min(5).max(30),
    // Документ удостоверения личности — единое поле (номер/серия, 9 или 11
    // символов для актуальных направлений). Серия больше не запрашивается
    // отдельно; поле оставлено опциональным для обратной совместимости со
    // старыми профилями (РФ-паспорт: серия+номер).
    passportSeries: z.string().max(20).optional().default(""),
    passportNumber: z.string().min(1).max(30),
});
export const recipientSchema = z.object({
    fullName: z.string().min(2).max(200),
    phone: z.string().min(5).max(30),
    passportSeries: z.string().max(20).optional().nullable(),
    passportNumber: z.string().max(30).optional().nullable(),
});
// Схемы создания/распознавания заказов архивного модуля Ozon/WB (itemSchema,
// createOrderSchema, updateItemsSchema, recognizeSchema, scanQrSchema,
// архивная create-схема, adminStatusChangeSchema) удалены 2026-06-12
// (волна 2 PR6): их потребители ушли в PR1-PR5, референс — ветка
// archive/ozonwb-flow (тег pre-ozonwb-extract).
// Optional query-filter schema for admin orders list — whitelist-only to avoid
// accepting arbitrary strings in `where.status.in`.
// .min(1) на string-полях, чтобы whitespace-only/пустая строка не утекали в
// where-предикат Prisma и не давали ложных совпадений.
export const adminOrdersQuerySchema = z.object({
    status: z
        .string()
        .min(1)
        .optional()
        .transform((s) => s
        ? s
            .split(",")
            .map((x) => x.trim())
            .filter((x) => ORDER_STATUSES.includes(x) ||
            SHOP_ORDER_STATUSES.includes(x))
        : undefined),
    direction: z.string().trim().min(1).max(50).optional(),
    search: z.string().trim().min(1).max(200).optional(),
    from: z.string().datetime().optional().or(z.literal("")),
    to: z.string().datetime().optional().or(z.literal("")),
    // Unified-aggregator selector. When omitted the route keeps its legacy
    // mixed Order+ShopOrder response; when set it returns UnifiedOrderRow[].
    type: z.enum(["flex", "shop", "all"]).optional(),
});
//# sourceMappingURL=index.js.map